import React from "react";
import AppPageHeader from "../../components/AppPageHeader";

const backButtonStyle = {
  padding: "4px 10px",
  cursor: "pointer",
  border: "1px solid #d0d0d0",
  background: "#fff",
  borderRadius: 0,
  color: "#3d3d3a",
  fontSize: "11px",
  lineHeight: 1.25,
  fontWeight: 600,
};

function AccountDetailHeader({ onBackToAccounts, onLogout, user, account }) {
  return (
    <AppPageHeader
      title={account ? `Account: ${account.account_name}` : "Account"}
      subtitle={
        account ? (
          <>
            Customer ID: {account.customer_id} | Account ID:{" "}
            {account.account_id}
          </>
        ) : null
      }
      user={user}
      onLogout={onLogout}
    >
      <div style={{ marginBottom: "8px" }}>
        <button type="button" onClick={onBackToAccounts} style={backButtonStyle}>
          ← Back to Accounts
        </button>
      </div>
    </AppPageHeader>
  );
}

export default AccountDetailHeader;
